import React, { createContext, useContext, useState } from 'react'
import { useSelector } from 'react-redux'

import { useCreateOrder } from './useCreateOrder'
import { FROM_HOMEPAGE } from 'settings/_scheduledFrom'
import { GPR_CONSULT } from 'settings/_productSettings'

type QuickSchedule = {
  startDate: Date
  endDate: Date
  professionalId: number
  professionalUrl: string
  professionalType: 'PSIC' | 'PSIQ'
  professionalAppointmentId: number
}

interface QuickScheduleContextData {
  quickSchedule: QuickSchedule
  setQuickSchedule: (quickSchedule: QuickSchedule) => void  
  handleCreateOrder: () => void
  isCreateOrderLoading: boolean
  clearQuickSchedule: () => void
}

interface AuthData {
  auth: {
    userData: {
      person_profile: {
        id: number
      }[]
    }
    planSelected: {
      partner_plan_code: string
    }
  }
}

export const QuickScheduleContext = createContext<QuickScheduleContextData>({} as QuickScheduleContextData)

export const QuickScheduleProvider: React.FC = ({ children }) => {
  const { onCreateOrder, isCreateOrderLoading } = useCreateOrder()
  
  const [quickSchedule, setQuickSchedule] = useState<QuickSchedule>(null)
  const userData = useSelector((state: AuthData) => state.auth.userData)
  const patientId: number = userData?.person_profile[0].id
  const planCode: string = useSelector((state: AuthData) => state.auth.planSelected?.partner_plan_code)
  const payload = {
    product_group_code: GPR_CONSULT,
    plan_code: planCode,
    profile_role: quickSchedule?.professionalType,
    person_profile_product_appointment_id: quickSchedule?.professionalAppointmentId,
    username: null,
    schedules: [{
      start_date: quickSchedule?.startDate.toISOString(),
      end_date: quickSchedule?.endDate.toISOString(),
      guests: [
        {
          person_profile_id : quickSchedule?.professionalId
        },
        {
          person_profile_id : patientId
        }
      ]
    }],
    scheduledFrom: FROM_HOMEPAGE,
  }
  
  function handleCreateOrder() {
    return onCreateOrder(payload)
  }

  function clearQuickSchedule() {
    setQuickSchedule(null)
  }
  
  return (
    <QuickScheduleContext.Provider value={{ 
      quickSchedule, 
      setQuickSchedule, 
      handleCreateOrder, 
      isCreateOrderLoading,
      clearQuickSchedule
    }}>
      {children}
    </QuickScheduleContext.Provider>
  )
}

export function useQuickSchedule(): QuickScheduleContextData {
  const context = useContext(QuickScheduleContext)
  
  return context
}